import {
  isUnlimitedOnlyEligibleUser,
  TUnlimitedOnlyEligibilityUser,
} from "./unlimitedOnlyPaywall";

// ALL-2140: the ALL-2079 A/B is over and every eligible player gets the earn
// loop. quentin's helpers/earnLoop makes the same call from the same inputs;
// if the two ever disagree, the modal offers a claim the backend refuses.
export type EarnLoopVariant = "control" | "treatment";

// Sends every player back to control without a code change.
export const EARN_LOOP_KILLED = process.env.REACT_APP_EARN_LOOP_KILL === "true";

// Null means outside the population, which readouts must not count as control.
export const earnLoopVariantOf = (
  user?: (TUnlimitedOnlyEligibilityUser & { _id?: string }) | null,
): EarnLoopVariant | null => {
  if (!user?._id || !isUnlimitedOnlyEligibleUser(user)) return null;
  return EARN_LOOP_KILLED ? "control" : "treatment";
};
